import PropTypes from 'prop-types';
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteField, getAllFields } from '../../../actions/promotion/fields';
import { If } from 'react-if';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import ReactDragListView from 'react-drag-listview';
import {
  Col,
  Row,
  Button,
  Input,
  Spinner,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { formatDate } from '../../../helpers/formatDate';
import { formatTime } from '../../../helpers/formatTime';
import { Link } from 'react-router-dom';
import AddFields from './AddFields';
import AlertDelete from './AlertDelete';
import { alertError, alertSuccess } from '../../../helpers/errorHandling';

// ==============================|| Field - LIST ||============================== //

const PromotionFields = () => {
  const [data, setData] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [field, setField] = useState(null);
  const [add, setAdd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState({});
  const [pageOffset, setPageOffset] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [direction] = useState('down');

  const getFields = async () => {
    setLoading(true);
    const { data, meta } = await getAllFields({
      pageOffset: Math.max(pageOffset - 1, 0),
      pageSize: 1000,
    });

    setTimeout(() => {
      setData(data);
      setMeta(meta);
      setLoading(false);
    }, 400);
  };

  useEffect(() => {
    getFields();
  }, [pageOffset]);

  const handleAdd = (f) => {
    if (f?._id) {
      setField({ ...f });
    } else {
      setField(null);
    }
    // navigate('/configurations/fields/addfields/new');
    setAdd(!add);

    // when closing and there is data in field object it get cleared
  };

  const handleClose = () => {
    setDeleteOpen(!deleteOpen);
  };

  const deleteUserHandler = async (fieldDeleteId) => {
    const res = await deleteField({ fieldId: fieldDeleteId });
    if (res?.deleteField?.success) {
      alertSuccess('Field deleted successfully');
      getFields();
      handleClose(true);
    } else {
      alertError('Failed!. Please try again later..');
    }
  };

  const handleRefreshData = () => {
    getFields();
  };
  const handlePageOffset = (value) => {
    setPageOffset(value);
  };
  const [showFieldModal, setEditFieldModal] = useState(null);
  const [showDeleteFieldModal, setDeleteFieldModal] = useState(null);

  //

  const toggleDropdown = (itemId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [itemId]: !prevState[itemId],
    }));
  };
  const dragProps = {
    onDragEnd: (fromIndex, toIndex) => {
      const newData = [...data];
      const item = newData.splice(fromIndex, 1)[0];
      newData.splice(toIndex, 0, item);
      setData(newData);
    },
    nodeSelector: 'tr, div',
    handleSelector: 'a',
  };
  return (
    <div className="page-content px-4 pb-0">
      <Row>
        <Col md={8} className="m-auto">
          <div
            // style={{ backdropFilter: ' blur(4px)' }}
            className="position-sticky top-0 z-1 d-flex justify-content-between align-items-center py-4 bg-white"
          >
            <h4 className="mb-0">Field</h4>
          </div>
          <Row>
            <Col sm={12} md={12} className="m-auto">
              <ReactDragListView {...dragProps}>
                <div className="position-relative d-flex flex-column">
                  <table className="table table-nowrap table-centered align-middle mb-0">
                    <thead
                      className="bg-light text-muted bg-light position-sticky text-muted w-100 z-1"
                      style={{ top: 71 }}
                    >
                      <tr>
                        <th></th>
                        <th>Field Group</th>
                        <th>Field Name</th>
                        <th>Field Code</th>
                        <th>Data Type</th>
                        <th>Field type</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(data || []).map((field, key) => (
                        <tr key={key}>
                          <td>
                            <a href="#" className="cursor-grab d-block">
                              <i className="bx bx-grid-vertical fs-18 text-muted"></i>
                            </a>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <div>
                                <h5 className="fs-13 my-1">
                                  {field?.fieldGroup}
                                </h5>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <div>
                                <h5 className="fs-13 my-1">
                                  {field?.fieldName}
                                </h5>
                              </div>
                            </div>
                          </td>
                          <td>
                            <h5 className="fs-13 my-1 fw-normal">
                              {field?.fieldCode}
                            </h5>
                          </td>
                          <td>
                            <h5 className="fs-13 my-1 fw-normal">
                              {field?.dataType}
                            </h5>
                          </td>
                          <td>
                            <h5 className="fs-13 my-1 fw-normal">
                              {field?.fieldType}
                            </h5>
                          </td>

                          <td>
                            <div className="d-flex flex-row align-items-center gap-2">
                              <div>
                                <If condition={showFieldModal === field?._id}>
                                  <AddFields
                                    fieldIdFromProps={field?._id}
                                    fieldDetailFromProp={
                                      field ? { ...field } : null
                                    }
                                    onCancel={() => {
                                      setEditFieldModal(null);
                                    }}
                                    getFields={getFields}
                                    show={true}
                                  />
                                </If>
                                {/* <Button
                                  color="primary"
                                  size="sm"
                                  onClick={() => {
                                    setEditFieldModal(field?._id);
                                  }}
                                >
                                  <i className="bx bx-edit fs-18"></i>
                                </Button> */}
                              </div>
                              <div>
                                <AlertDelete
                                  open={field?._id === showDeleteFieldModal}
                                  hideButton
                                  deleteHandler={() =>
                                    deleteUserHandler(field?._id)
                                  }
                                />
                              </div>
                              {/*  */}
                              <Dropdown
                                isOpen={dropdownOpen[key]}
                                toggle={() => toggleDropdown(key)}
                                direction={direction}
                              >
                                <DropdownToggle className="bg-transparent border-0 p-0 shadow-none text-dark ms-auto">
                                  <i className="bx bx-dots-horizontal-rounded fs-20"></i>
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem
                                    className="fs-13 d-flex align-items-center gap-1"
                                    onClick={() =>
                                      setEditFieldModal(field?._id)
                                    }
                                  >
                                    <i className="bx bx-pencil"></i>
                                    Edit
                                  </DropdownItem>
                                  <DropdownItem
                                    className="fs-13 d-flex align-items-center gap-1 text-danger"
                                    onClick={() =>
                                      setDeleteFieldModal(field?._id)
                                    }
                                  >
                                    <i className="bx bx-trash"></i>
                                    Delete
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </ReactDragListView>

              <div
                style={{ backdropFilter: ' blur(4px)' }}
                className="position-sticky bottom-0 z-1 d-flex justify-content-center align-items-center py-3 border-top"
              >
                <div className="d-flex flex-wrap align-items-start justify-content-center w-100 gap-2">
                  <span onClick={handleAdd} className="cursor-pointer">
                    <i className="bx bx-plus"></i> Add New Field
                  </span>
                  <AddFields
                    fieldIdFromProps={'new'}
                    fieldDetailFromProp={null}
                    onCancel={handleAdd}
                    getFields={getFields}
                    show={add}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default PromotionFields;
